import {
    ActivityChallengeParticipantStatusEnum,
    getApolloErrorUiMessage,
    useBasicActivityChallengeListDataQuery,
} from '@lingoda/monolith-graphql';
import { Box, Stack, Typography } from '@lingoda/ui';
import { trans } from '@lingoda/i18n';
import { showErrorToast } from '@lingoda/toasts';
import { MyChallengesBoardLayout } from './MyChallengesBoardLayout';

export const MyChallengesBoard = () => {
    const { data } = useBasicActivityChallengeListDataQuery({
        variables: {
            canJoinOnly: false,
        },
        onError(error) {
            showErrorToast(getApolloErrorUiMessage(error) || trans('masked-error', {}, 'errors'));
        },
    });

    const activityChallenges = (data?.activityChallenges ?? []).filter(
        (challenge) =>
            challenge.currentParticipant?.status === ActivityChallengeParticipantStatusEnum.Joined,
    );

    if (!activityChallenges?.length) {
        return null;
    }

    return (
        <Stack spacing={2}>
            <Typography variant="h3">{trans('challenges', {}, 'student-challenges')}</Typography>
            <Box>
                <MyChallengesBoardLayout activityChallenges={activityChallenges} />
            </Box>
        </Stack>
    );
};
